<template>
  <div>
    <van-popup
      v-model="isPwd"
      position="right"
      :style="{ height: '100%',width:'100%',background: '#f5f5f5' }"
    >
      <van-nav-bar :style="{'background-color':'#f9f9f9'}">
        <van-icon size="20" slot="left" @click="close" name="arrow-left" color="#333" />
        <div slot="title">修改密码</div>
      </van-nav-bar>
      <van-cell-group>
        <van-field
          v-model="old"
          :type="passwordType1"
          v-validate="'required|pwd'"
          :error-message="errors.first('您输入的密码格式错误')"
          required
          clearable
          label="原密码"
          placeholder="请输入原密码"
          :right-icon="oldPwdIsShow?'eye':'closed-eye'"
          @click-right-icon="oldPwd"
        />
        <van-field
          v-model="newPwd"
          :type="passwordType2"
          v-validate="'required|pwd'"
          :error-message="errors.first('您输入的密码格式错误')"
          label="新密码"
          required
          placeholder="请输入新密码"
          :right-icon="newPwdIsShow?'eye':'closed-eye'"
          @click-right-icon="newPwdBtn"
        />
        <van-field
          v-model="checkNewPwd"
          :type="passwordType3"
          v-validate="'required|pwd'"
          :error-message="errors.first('您输入的密码格式错误')"
          label="确认新密码"
          required
          placeholder="请再次输入新密码"
          :right-icon="agenNewPwdIsShow?'eye':'closed-eye'"
          @click-right-icon="newAgenPwdBtn"
        />
      </van-cell-group>
      <div class="change-pwd" @click="submitBtn">确认修改</div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "centerpwd",
  props: {
    isPwd: Boolean
  },
  data() {
    return {
      passwordType1: "password",
      passwordType2: "password",
      passwordType3: "password",
      old: "",
      newPwd: "",
      checkNewPwd: "",
      letterList: [],
      oldPwdIsShow: false,
      newPwdIsShow: false,
      agenNewPwdIsShow: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    oldPwd() {
      this.oldPwdIsShow = !this.oldPwdIsShow;
      this.passwordType1 = this.oldPwdIsShow ? "text" : "password";
    },
    newPwdBtn() {
      this.newPwdIsShow = !this.newPwdIsShow;
      this.passwordType2 = this.newPwdIsShow ? "text" : "password";
    },
    newAgenPwdBtn() {
      this.agenNewPwdIsShow = !this.agenNewPwdIsShow;
      this.passwordType3 = this.agenNewPwdIsShow ? "text" : "password";
    },
    close() {
      this.$emit("listenToPwd", false);
    },
    async submitBtn() {
      if (this.newPwd.trim() === this.checkNewPwd.trim()) {
        if (
          this.old.trim().length === 0 ||
          this.newPwd.trim().length === 0 ||
          this.checkNewPwd.trim().length === 0
        ) {
          this.xy.msgError("密码不能为空");
        } else {
          this.xy.loading();
          let res = await this.xyapi.post(
            `${this.xyMApi}/api/Users/ChangeUsersPassword`,
            {
              oldPassword: this.old,
              newPassword: this.newPwd,
              newConfirmPassword: this.checkNewPwd
            }
          );
          if (res.success) {
            this.xy.msgSuc("密码修改成功");
            this.$emit("listenToPwd", false);
          }
          this.xy.unloading();
        }
      } else {
        this.xy.msgError("新密码输入的不一致");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.change-pwd {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  height: 80px;
  width: 54%;
  margin: 100px auto 0;
  border-radius: 40px;
  background-color: #4196ff;
  color: #fff;
}
</style>